import authTypes from '../actions/auth.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {
        case authTypes.STORE_LOGIN:
            return {
                ...state,
                username: action.payload.username,
                status: action.payload.status,
                message: action.payload.message
            }

        case authTypes.CHANGE_STATUS:
            return {
                ...state,
                status: 'authenticated'
            }

        case authTypes.SEND_LOGOUT:

            localStorage.clear();
            return {
                status: 'not-authenticated'
            }

        case authTypes.CHANGE_PASSWORD_MESSAGE:
            return {
                ...state,
                message: "La contraseña ha sido cambiada",
                cambioClave: !action.payload.response.result
            }

        case authTypes.CLEAR_MESSAGES:
            return {
                ...state,
                message: ''
            }

        case authTypes.STORE_USER:
            return {
                ...state,
                message: (action.payload.user.cambiarClave) ? 'Por favor, cambie la contraseña para poder continuar.' : null,
                cambioClave: action.payload.user.cambiarClave,
                isAdminUnregpol: action.payload.user.adminUnregpol,
                username: action.payload.user.usuario,
                nombre: action.payload.user.nombre
            }

        default:
            return state;
    }
};

export default reducer;

var initialEntries = [];